const APP_HOST = 'https://app.loyalclub.ru';
const API_HOST = 'https://api.loyalclub.ru';

const api = {
  appHost: APP_HOST,
  host: API_HOST,
  publicV1: `${API_HOST}/api/v1`,
  moyskladLoyalty: `${API_HOST}/moysklad/loyalty`,
};

const tr = (lang, ru, en) => (lang === 'en' ? en : ru);

export { APP_HOST, API_HOST, api, tr };
